var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",attrs:{"idx":_vm.idx,"policy":_vm.policy}})
}
var staticRenderFns = []

export { render, staticRenderFns }